import React, { useState } from 'react';
import { IonButton, IonRouterLink } from '@ionic/react';

interface Props {}

const RGPDToast: React.FC<Props> = (props) => {
  const [rgpdAcknowledged, setRgpdAcknowledged] = useLocalStorage(
    'rgpdAcknowledged',
    false
  );
  const [, setRgpdAccepted] = useLocalStorage('rgpdAccepted', false);
  const [showRGPDToast, setShowRGPDToast] = useState(!rgpdAcknowledged);

  const closeRGPD = () => {
    setRgpdAcknowledged(true);
    setShowRGPDToast(false);
  };

  const acceptRGPD = () => {
    setRgpdAccepted(true);
    closeRGPD();
  };

  const refuseRGPD = () => {
    setRgpdAccepted(false);
    closeRGPD();
  };

  return showRGPDToast ? (
    <div className="toast-rgpd">
      <div className="wrapper">
        <div className="toast-rgpd__inner">
          Ce site Internet utilise des cookies pour améliorer la navigation et
          votre expérience. En continuant sur ce site, vous acceptez
          l’utilisation de cookies. Si vous souhaitez plus d'informations ou ne
          souhaitez pas l’enregistrement de cookies lorsque vous parcourez ce
          site, merci de vous rendre sur notre page{' '}
          <IonRouterLink routerLink="/dashboard/data-protection">
            Data Protection
          </IonRouterLink>
          .
          <div className="toast-rgpd__btns ion-margin-top">
            <IonButton onClick={() => acceptRGPD()}>Accepter</IonButton>
            <IonButton onClick={() => refuseRGPD()} fill="clear">
              Décliner
            </IonButton>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

// Hook

function useLocalStorage(key: string, initialValue: any) {
  // State to store our value

  // Pass initial state function to useState so logic is only executed once

  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key

      const item = window.localStorage.getItem(key);

      // Parse stored json or if none return initialValue

      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue

      console.log(error);

      return initialValue;
    }
  });

  // Return a wrapped version of useState's setter function that ...

  // ... persists the new value to localStorage.

  const setValue = (value: any) => {
    try {
      // Allow value to be a function so we have same API as useState

      const valueToStore =
        value instanceof Function ? value(storedValue) : value;

      // Save state

      setStoredValue(valueToStore);

      // Save to local storage

      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      // A more advanced implementation would handle the error case

      console.log(error);
    }
  };

  return [storedValue, setValue];
}

export default RGPDToast;
